var exports = {
  "d$": "xaee3c4fa--e4638b--arrows",
  "iE": "xaee3c4fa--e4638b--wrapper",
  "d6": "xaee3c4fa--e4638b--fullscreen-overlay",
  "L0": "xaee3c4fa--e4638b--fullscreen-button",
  "_R": "xaee3c4fa--e4638b--close-button",
  "UE": "xaee3c4fa--e4638b--arrow",
  "iQ": "xaee3c4fa--e4638b--arrow-prev",
  "s7": "xaee3c4fa--e4638b--arrow-next",
  "h_": "xaee3c4fa--e4638b--description",
  "Il": "xaee3c4fa--e4638b--description-inner",
};

module.exports = exports;
